.kr{bottom:calc(100% + 0.25rem);}